import './style/index';

import _Watermark from './watermark';

export type { WatermarkProps } from './watermark';

export const Watermark = _Watermark;

export default Watermark;
